import React, { useState } from "react";
import { AutoComplete, Form, Select } from "antd";
import { createUseStyles } from "react-jss";

const { Option } = Select;

const UICitySelect = ({
  style = {},
  label,
  name,
  required,
  defaultValue,
  rules,
  validateStatus,
  hasFeedback,
  help,
  disabled,
  cities = {},
  onChange
}) => {
  const styles = useStyles();

  const onCitySearch = (value) => {
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <Form.Item
      label={<span style={{ fontSize: "16px", fontWeight: "500" }}>{label}</span>}
      name={name}
      required={required}
      rules={rules}
      hasFeedback={hasFeedback}
      help={help}
      validateStatus={validateStatus}
      initialValue={defaultValue}
    >
    <AutoComplete
    className={styles.customSelect}
    style={{ padding: "12px 10px !important" , fontSize: '16px' , fontWeight: "500" , ...style }}
    onSelect={(e) => onCitySearch(e)}
    onSearch={(e) => onCitySearch(e)}
    placeholder=""
    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
    defaultValue={cities?.citiesData}
  >
    {cities?.citiesData && Object.values(cities?.citiesData)?.map((item, index) => {
      return (
        <Option key={index} value={Object.values(cities?.citiesData)[index]}>
          {item}
        </Option>
      );
    })}
  </AutoComplete>
     </Form.Item>
  );
};

export default UICitySelect;

const useStyles = createUseStyles({
  customSelect : {
    height: "51px !important",
    fontsize: "16px"
  }
});

